import React from "react";
import { useNavigate } from "react-router-dom";
import BondBasicInformationBase from "../../shared/components/BondBasicInformationBase";
import { BOND_BASIC_INFO_CONFIG } from "../../shared/bondBasicInformationConfig";
import { BOND_STEP_BASIC_PROBATE } from "../../shared/bondWizardStepPropTypes";

const BasicInformation = (props) => {
  const navigate = useNavigate();
  const config = { ...BOND_BASIC_INFO_CONFIG.probate, navigate };
  return <BondBasicInformationBase config={config} {...props} />;
};

BasicInformation.propTypes = BOND_STEP_BASIC_PROBATE;

export default BasicInformation;
